import React, { useState, useEffect } from 'react';
import TemplatesItem from './TemplatesItem';
import Sidebar from '../Home/components/Sidebar';
import Tabs from '../Home/components/Tabs';

const TemplatesContent = () => {
  const [activeTab, setActiveTab] = useState('');

  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/workflows_templates/list`
        );
        if (response.ok) {
          const data = await response.json();
          setTemplates(data);
        }
      } catch (error) {
        console.error('Error fetching templates:', error);
      }
    };
    fetchTemplates();
  }, []);

  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      <Sidebar />
      <div style={{ padding: '20px', flexGrow: 1 }}>
        <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />

        {templates.length > 0 ? (
          templates.map((template, index) => (
            <TemplatesItem
              key={template.id}
              title={template.workflow_name}
              description={`Template ${index + 1}: ${template.workflow_name}`}
              // Uncomment below to handle template clicks if needed
              // onClick={() => handleTemplateClick(template)}
              // onDelete={() => console.log('Delete template:', template.id)}
            />
          ))
        ) : (
          <p>No templates found.</p>
        )}
      </div>
    </div>
  );
};

export default TemplatesContent;
